import React, {useEffect, useState} from 'react';
import '../App.css';
import { Alert } from 'react-bootstrap';
import Axios from 'axios';
import ReportHeader from "../components/reports/ReportsHeader";
import Grillabowalletmovreport from "./grillabowalletmovreport";

import Bodyheaderloged from './bodyheaderloged'


function Bodymovwalletreport (props){

    const [urlminuta, setUrlMinuta] = useState()

    const GetMinuta = () =>
    {
        let idcasino = window.localStorage.getItem('MY_APP_STATE_PROF_CASINO_ID').replace('"', '')
        Axios.get(process.env.REACT_APP_URLDOWNLOADFILE, {
            params: {
                casino_id: idcasino.replace('"', ''),
            }, 
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setUrlMinuta(response.data.UrlFile)
        }).catch(error => {
            return error     
        })
    }

    

    useEffect(() => {
        GetMinuta()
    }, []);

    return (
        <div className='w-full'>
            <div className='flex justify-start w-full'>
                <Bodyheaderloged mailloginP={props.mailloginP} apptokenP={props.apptokenP} setStateMailP={props.setStateMailP}/>
            </div>
            <div className='flex justify-start w-full'>
                <Grillabowalletmovreport/>
            </div>
        </div>

    )
}
export default Bodymovwalletreport